import { useState, useEffect } from 'react';

/**
 * Custom hook for tracking mouse position
 * @param {boolean} enabled - Whether mouse tracking is enabled
 * @returns {object} - { x, y, isMouseMoving }
 */
const useMousePosition = (enabled = true) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMouseMoving, setIsMouseMoving] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    let timeoutId;
    
    const handleMouseMove = (event) => {
      setMousePosition({
        x: event.clientX,
        y: event.clientY
      });
      
      setIsMouseMoving(true);
      
      // Reset isMouseMoving after a short delay
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMouseMoving(false);
      }, 100);
    };

    // Use passive listener for better performance
    window.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(timeoutId);
    };
  }, [enabled]);

  return { ...mousePosition, isMouseMoving };
};

export default useMousePosition;
